/**
 * 评价弹框 因为Modal.confirm中的content有bug：更新state但是content不re-render
 */
import { FC, useContext, useState, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { evalOrderApi } from '@/api/home'
import { Button, Modal, Toast, TextArea, Form } from 'antd-mobile'
import css from '@/pages/user/My/index.module.less'
import { StarFill, StarOutline } from 'antd-mobile-icons'
import { ORDER_STATUS_EVALUATED, UpdateOrderContext } from '@/pages/user/My'
import { workProbe } from '@/api/user'
import {
  DynamicFormItem,
} from '@/pages/home/AddOrder/components/DynamicFormItem'
import Loading from '../loading'

// 评价按钮
export const BtnEval: FC<{
  order: any,
}> = ({ order }) => {
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation();
  return (
    <>
      <Button className={css.BtnScore} color='primary' fill='none' onClick={() => setVisible(true)}>
        <StarOutline className={'font-16 mgr-5'} /><span>{t('user-center.eva.eva-btn')}</span>
      </Button>
      <EvalModal visible={visible} setVisible={setVisible} order={order} />
    </>
  )
}

// 新评价按钮
export const BtnEvalNew: FC<{
  order: any,
}> = ({ order }) => {
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation();
  return (
    <>
      <Button className={css.newBtnScore} color='primary' fill='none' onClick={() => setVisible(true)}>
        <span>{t('user-center.eva.eva-btn')}</span>
      </Button>
      <EvalModal visible={visible} setVisible={setVisible} order={order} />
    </>
  )
}

// 回复按钮
export const BtnReply: FC<{
  order: any,
}> = ({ order }) => {
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation();
  return (
    <>
      <Button className={css.replyBtnScore} color='primary' fill='none' onClick={() => setVisible(true)}>
        <span>{t('user-center.eva.reply-btn')}</span>
      </Button>
      <ReplyModal visible={visible} setVisible={setVisible} order={order} />
    </>
  )
}


export const EvalModal: FC<{
  visible: boolean,
  setVisible(visible: boolean): any,
  order: any,
}> = ({ visible, setVisible, order }) => {
  const { t } = useTranslation();
  const [starsNum, setStarsNum] = useState(process.env.REACT_APP_IDN_ENV === 'hw' ? 5 : 0);
  const setOrderList = useContext(UpdateOrderContext);

  // 点击操作按钮
  const onBtnActionClick = async (action: any, index: number) => {
    if (action.key === 'confirm') {
      const res = await evalOrderApi({ id: order.id, starsNum })
      if (res?.code === 0) {
        Toast.show({ icon: 'success', content: `${t('user-center.eva.eva-tips')}` });
        order.workOrderStatus = ORDER_STATUS_EVALUATED;
        order.workOrderStatusName = `${t('user-center.eva.eva-done')}`;
        order.starsNum = starsNum
        
        if (order?.workOrderReplyAgain.length > 0) {
          order.workOrderReplyAgain[0].replyFlag = 0
        }

        setOrderList(prevState => ([...prevState]));
      }
    }
    setVisible(false);
  }

  return (
    <Modal
      visible={visible}
      bodyClassName={css.EvalModal}
      title={`${process.env.REACT_APP_IDN_ENV === 'hw' ? t('user-center.eva.reply-title2') : t('user-center.eva.eva-title')}`}
      content={
        <>
          {process.env.REACT_APP_IDN_ENV === 'hw' && (
            <div className={css.EvalModalTips}>{t('user-center.eva.eva-tips-1')}</div>
          )}
          <div className={css.StarBar}>
            {
              Array(5).fill(0).map((_, index) => (
                <StarFill key={index} className={`${css.EvalStar} ${starsNum > index ? css.Active : ''}`} onClick={() => setStarsNum(index + 1)} />
              ))
            }
          </div>
        </>
      }
      actions={[
        { key: 'confirm', text: `${t('common.submit')}`, primary: true },
        { key: 'cancel', text: `${t('common.cancel')}` },
      ]}
      onAction={onBtnActionClick}
    />
  )
}

export const ReplyModal: FC<{
  visible: boolean,
  setVisible(visible: boolean): any,
  order: any,
}> = ({ visible, setVisible, order }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm(); 
  const isClick = useRef(false);
  
  const onFinish = async (values) => {
    const { content, ext } = values;
    const imageUrls = ext['']?.map((item: any) => item.url);
    if (isClick.current) return;
    isClick.current = true;
    const res = await workProbe({ workOrderId: order.id, content, imageUrls });
    isClick.current = false;
    if (res?.code === 0) {
      Toast.show({ icon: 'success', content: `${t('user-center.eva.reply-tips')}` });
      setVisible(false);
      window.location.reload();
    }
  }

  return (
    <Modal
      visible={visible}
      content={
        <div className={css.ReplyModal}>
          {
            isClick.current && (
              <div className={css.ReplyModalLoading}><Loading /></div>
            )
          }
          <div className={css.ReplyModalHd}>{t('user-center.eva.reply-title')}</div>
          <Form
            form={form}
            onFinish={onFinish}
            footer={
              <>
                <Button block className={css.ReplyModalBtn} type='submit' color='primary' size='large'>{t('user-center.eva.reply-btn')}</Button>
                <Button block color='primary' fill='none' size='large' onClick={() => setVisible(false)}>{t('common.cancel')}</Button>
              </>
            }
          >
            <Form.Item className={css.ReplyModalTextArea} name='content' rules={[{ required: true, message: t('user-center.eva.reply-title') }]}>
              <TextArea
                placeholder={t('user-center.eva.reply-desc')}
              />
            </Form.Item>
            <DynamicFormItem config={{
              "id": 22,
              "fieldName": "",
              "fieldType": 6,
              "fieldSystem": 1,
              "checkEnable": 0,
              "reqEnable": 0,
              "presetContext": ""
            }} />
          </Form>
        </div>
      }
    />
  );
};
